(function(){
	'strict';

	const _inserted = Symbol('_inserted');

	function getPart(item, part) {
		return item === undefined || item === null
			? item
			: typeof part == 'function'
			? part(item)
			: typeof item != 'object'
			? item.toString()
			: typeof part == 'string' && part in item
			? (item[part] === null || item[part] === undefined) ? null : item[part].toString()
			: item.toString();
	}

	Vue.component('select-one', {
		props: {
			value: {
				required: false,
			},
			options: {
				type: Array,
				default: [],
			},
			optional: {
				type: Boolean,
				default: true,
			},
			placeholder: {
				type: String,
				default: null,
			},
			clearOnSelect: {
				type: Boolean,
				default: false,
			},
			resetAfter: {
				type: Boolean,
				default: false,
			},
			searchable: {
				type: Boolean,
				default: true,
			},
			asObject: {
				type: Boolean,
				default: true,
			},
			preserveSearch: {
				type: Boolean,
				default: false,
			},
			label: {
				type: [String, Function],
				default: 'text',
			},
			sublabel: {
				type: [Boolean, String, Function],
				default: false,
			},
			trackBy: {
				type: [String, Function],
				default: 'id',
			},
			disabled: {
				type: [Boolean, String], // eval as bool
				default: false,
			},
			disableOnNoOptions: {
				type: [Boolean, String], // eval as bool
				default: true,
			},
			tag: {
				type: [Boolean, Function], // eval as bool
				default: false,
			},
			autoSelect: {
				type: Boolean,
				default: true,
			},
			tabindex: {
				type: [String, Number],
				default: 0,
			},
			startEmpty: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				filterText: '',
				open: false,
				filterIndex: 0,
				selectedIndex: -1,
				inNav: false,
				oldFilterText: '',
				[_inserted]: false,
			};
		},
		created() {
			if ( this.startEmpty )
				return;
			if (!this.optional && (this.value === undefined || this.value === null) && this.options[0] !== undefined)
				this.$emit('input', this.asObject ? this.options[0] : getPart(this.options[0], this.trackBy));
			if ( this.options ) {
				const id = getPart(this.value, this.trackBy);
				this.selectedIndex = this.options ? this.options.findIndex( option => getPart(option, this.trackBy) == id ) : -1;
				this.filterIndex = this.selectedIndex >= 0 ? this.selectedIndex : 0;
				if(this.optional && !this.filterText){
					this.filterText = id;
				}
			}
		},
		methods: {
			getPart,
			filterOptions(text, options = undefined) {
				if (options === undefined)
					options = this.options;
				text = text === undefined || text === null ? '' : text.toString().toUpperCase();
				return options.filter(i => {
					const part = getPart(i, this.label);
					return part !== undefined && (part !== null)
						&& part.toString().toUpperCase().indexOf(text) === 0;
				});
			},
			findIndexIn(options, value, part = true) {
				if ( part !== false )
					value = getPart(value, part === true ? this.trackBy : part);
				return options.findIndex(i => getPart(i, this.trackBy) == value);
			},
			findIn(options, value, part = true) {
				if ( part !== false )
					value = getPart(value, part === true ? this.trackBy : part);
				return options.find(i => getPart(i, this.trackBy) == value);
			},
			set(item) {
				if ( this.value === item || this.value == getPart(item, this.trackBy)) { return; }
				//console.log('setFilterTextAndOpen(', item);
				this.open = false;
				const itemFromOptions = this.findIn(this.options, item);
				if (itemFromOptions)
					this.$emit('input', this.asObject ? itemFromOptions : getPart(itemFromOptions, this.trackBy));
				else if (this.tag)
					this.$emit('input', this.asObject ? item : getPart(item, this.trackBy));
				if (this.clearOnSelect || this.resetAfter) {
					this.filterText = '';
					this.filterIndex = -1;
					this.selectedIndex = -1;
				}
				if (this.resetAfter)
					this.$emit('input', null);
				this.$emit('selected', this.asObject ? item : getPart(item, this.trackBy));
				this.$refs.input.focus();
			},
			enter() {
				event.stopPropagation();
				event.preventDefault();
				if ( this.open && this.filterIndex >= 0 ) {
					const items = this.filteredItems[this.filterIndex];
					const item = (items instanceof Array && items.length) ? items[0] : items;
					if (item) {
						this.filterText = getPart(item, this.label);
						this.filterIndex = 0;
						this.selectedIndex = 0;
						this.set(item);
					}
					//console.log('enter', {items, item, filterIndex: this.filterIndex});
					//this.$emit('selected', this.asObject ? item : getPart(item, this.trackBy));
				}
				this.open = !this.open;
				this.$refs.input.focus();
			},
			up(event) {
				event.stopPropagation();
				event.preventDefault();
				if (this.open) {
					if (this.filterIndex >= 0) {
						this.inNav = true;
						if ( --this.filterIndex >= 0 )
							this.$refs.filtered[this.filterIndex].firstChild.focus();
						this.$refs.input.focus();
						this.inNav = false;
					}
				}
				this.open = true;
			},
			down(event) {
				event.stopPropagation();
				event.preventDefault();
				if (this.open) {
					if (this.filterIndex < this.filteredItems.length - 1) {
						this.inNav = true;
						this.$refs.filtered[++this.filterIndex].firstChild.focus();
						this.$refs.input.focus();
						this.inNav = false;
					}
				}
				this.open = true;
			},
			esc(event) {
				event.stopPropagation();
				event.preventDefault();
				if (this.open) {
					if ( this.searchable && this.filterText )
						this.filterText = '';
					else {
						this.open = false;
						this.filterIndex = this.selectedIndex;
						this.filterText = getPart(this.value, this.label);
					}
				} else if(this.selectedIndex != this.filterIndex) {
					this.filterIndex = this.selectedIndex;
					this.filterText = getPart(this.value, this.label);
				} else if (!this.filterText && this.optional) {
					//this.$emit('input', null);
					this.filterText = getPart(this.value, this.label);
				} else {
					this.filterText = '';
					this.filterIndex = 0;
				}
			},
			setFilterTextAndOpen(event) {
				//console.log('setFilterTextAndOpen(', event);
				event.stopPropagation();
				event.preventDefault();
				if (this.searchable) {
					const old = this.filterText;
					this.filterText =
						this.open || event.target.value != getPart(this.value, this.label)
						? event.target.value
						: this.preserveSearch
						? this.oldFilterText
						: '';
					//console.log('emitting filter-text-updated', this.filterText, old);
					this.$emit('filter-text-updated', this.filterText, old);
				}
				if ('insertText' == event.inputType || 'insertFromPaste' == event.inputType
					|| 'deleteContentForward' == event.inputType || 'deleteContentBackward' == event.inputType)
					this.$data[_inserted] = true;
				if (this.autoSelect && this.filteredItems.length == 1 && this.filteredItems[0]) {
					const value = this.filteredItems[0];
					this.filterText = getPart(value, this.label);
					this.$emit('input', value);
					this.open = false;
				} else if (!this.inNav)
					this.open = true;
			},
			//TODO: fix closing
			toggleOpen(event) {
				//console.log('toggleOpen(', event);
				event.stopPropagation();
				event.preventDefault();
				this.open = !this.open;
				this.$refs.input.focus();
			},
			onBlur(event) {
				//console.log('onBlur(', event);
				this.open = false;
			},
			//TODO: fix closing
			clearSearch(event) {
				//console.log('clearSearch(', event);
				event.stopPropagation();
				event.preventDefault();
				const clear = !this.filterText;
				this.filterText = '';
				this.$refs.input.focus();
				if ((clear || !this.open) && this.optional)
					this.$emit('input', null);
			},
			selectSearch(event) {
				//console.log('selectSearch(', event);
				if (this.$data[_inserted]) {
					this.$data[_inserted] = false;
				} else {
					this.$refs.input.select();
					this.$refs.input.setSelectionRange(0, this.$refs.input.value.length);
				}
				if (this.$refs.input !== document.activeElement )
					this.$refs.input.focus();
			},
			keydownWrapper(event) {
				//console.log('keydownWrapper(', event);
				if (!this.filterText && event.key == 'Delete') {
					event.stopPropagation();
					event.preventDefault();
					this.filterText = '';
					this.$refs.input.focus();
					this.$emit('input', null);
				}
			},
		},
        computed: {
			filteredItems() {
				//console.log('computed filteredItems');
				//TODO: replace fallback with empty after adding safety checks.
				if (!(this.options instanceof Array) || !this.options.length)
					return [this.value];
				if (!this.searchable || !this.filterText)
					return this.options;
				const filtered = this.filterOptions(this.filterText);
				return filtered.length ? filtered : [this.value];
			},
		},
		watch: {
			value(value, oldValue) {
				if ( value === oldValue ) { return }
				//console.log('watch value(', value, oldValue);
				this.open = false;
				if ( value === undefined || value === null ) {
					this.filterText = '';
					this.selectedIndex = -1;
					this.filterIndex = -1;
					return;
				}
				if (getPart(value, this.trackBy) == getPart(oldValue, this.trackBy)) { return; }
				this.filterText = this.asObject ? getPart(value, this.label) || '' : value;
				if ( document.activeElement === this.$refs.input )
					this.$refs.input.setSelectionRange(0, this.$refs.input.value.length);
				if (getPart(value, this.trackBy) != getPart(oldValue, this.trackBy)) {
					this.selectedIndex = this.findIndexIn(this.filteredItems, value);
					this.filterIndex = this.selectedIndex;
				}
			},
			options(value, oldValue) {
				//console.log('watch options(', value, oldValue);
				if (value == oldValue) { return; }
				const oldFiltered = this.filterOptions(this.filterText, oldValue);
				const filtered = this.filterOptions(this.filterText, value);
				this.selectedIndex = this.findIndexIn(filtered, this.value);
				this.filterIndex = this.findIndexIn(filtered, oldFiltered[this.filterIndex]);
				//TODO: What if selectedIndex == -1?
				//this.$emit('input', this.value);
			},
			filteredText(value, oldValue) {
				//console.log('watch filteredText(', value, oldValue);
				if (value == oldValue) { return; }
				const oldFiltered = this.filterOptions(oldValue);
				const filtered = this.filterOptions(value);
				this.selectedIndex = this.findIndexIn(filtered, this.value);
				this.filterIndex = this.findIndexIn(filtered, oldFiltered[this.filterIndex]);
				//console.log('emitting filter-text-updated', value, oldValue);
				this.$emit('filter-text-updated', value, oldValue);
			},
			open(value, oldValue) {
				if (value == oldValue) { return; }
				//console.log('watch open(', value, oldValue);
				if (value) {
					const inNav = this.inNav;
					this.inNav = true;
					let id = undefined;
					if ( 0 >= this.selectedIndex ) {
						const filtered = this.filteredItems;
						if (filtered.length > this.selectedIndex) {
							id = getPart(filtered[this.selectedIndex], this.trackBy );
						}
					}
					this.selectedIndex = this.findIndexIn(this.filteredItems, id, false);
					this.filterIndex = this.selectedIndex;
					const entry = this.$refs.filtered[this.filterIndex];
					if (entry)
						entry.firstChild.focus();
					this.selectSearch();
					this.inNav = inNav;
				} else {
					if (this.inNav) { return; }
					this.inNav = true;
					if (this.preserveSearch)
						this.oldFilterText = this.filterText;
					if (this.tag) {
						this.$emit('input', typeof this.tag === 'function' ? this.tag(this.filterText) : this.filterText);
					} else {
						const filterText = getPart(this.value, this.label);
						if (this.filterText != filterText) {
							//console.log('emitting filter-text-updated', filterText, this.filterText);
							this.$emit('filter-text-updated', filterText, this.filterText);
							this.filterText = filterText;
						}
					}
					this.inNav = false;
				}
			},
		},
		template:
			`<div class="select-one">
				<div class="with-dropdown">
					<div class="search">
						<div class="controls" @mousedown.prevent="$refs.input.focus()">
							<span v-if="optional" :class="'fas ' + (!filterText ? (value ? 'fa-minus' : 'invisible') : open ? 'fa-backspace' : 'fa-minus')"
								@click="clearSearch"
							></span><span :class="'fas fa-angle-' + (open ? 'up' : 'down')"
								@click="toggleOpen"></span>
						</div>
						<div class="input-wrapper" @keydown="keydownWrapper">
							<input ref="input" type="text" autocomplete="nocomplete"
								:value="filterText"
								:placeholder="placeholder"
								:readonly="!searchable"
								:disabled="disabled || (disableOnNoOptions && !tag && (!options || !options.length))"
								:tabindex="tabindex"
								@input="setFilterTextAndOpen"
								@keydown.enter="enter"
								@keydown.down="down"
								@keydown.up="up"
								@keydown.esc="esc"
								@focusin="$refs.input.setSelectionRange(0, $refs.input.value.length)"
								@blur="onBlur" />
						</div>
					</div>
					<ul v-show="open" class="filteredItems">
						<li v-for="(item, index) in filteredItems" ref="filtered" :class="{'active': index == filterIndex}"
							class="btn-ty"><a tabindex="-1" href="#" @mousedown.prevent="set(item)"
						>{{getPart(item, label)}}<i v-if="sublabel !== false"> &nbsp; - {{getPart(item, sublabel)}}</i></a>
						</li>
					</ul>
				</div>
			</div>`
	});
})();
